export const supportedResources = [
  'AllergyIntolerance',
  'AuditEvent',
  'CareTeam',
  'ChargeItemDefinition',
  'Claim',
  'ClinicalImpression',
  'Communication',
  'Condition',
  'Coverage',
  'Device',
  'DeviceUseStatement',
  'DiagnosticReport',
  'Encounter',
  'Group',
  'Location',
  'Media',
  'Observation',
  'Organization',
  'Patient',
  'Practitioner',
  'PractitionerRole',
  'RelatedPerson',
  'ServiceRequest',
  'Task',
  'MedicationRequest',
  'ActivityDefinition',
  'PlanDefinition',
  'CarePlan',
  'Questionnaire',
  'Appointment',
  'DocumentReference',
  'Flag',
] as const;
export type SupportedResourceType = (typeof supportedResources)[number];
export const supportedResourceSet = new Set(supportedResources);
